import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useSelector, useDispatch } from "react-redux";
import { pushNotification } from "utils/notifications";
import {
  getListHopDongChoDuyet,
  updateDataSearch,
} from "../../../../../actions/DanhSachHopDongChoDuyet";
import DanhSachHopDongChoDuyetApi from "../../../../../service/danhSachHopDongChoDuyetApi";
import CheckNoXauApi from '../../../../../service/checkNoXauApi';
export const ModalXacNhanGiaoTien = (props) => {
  const dispatch = useDispatch();
  const listHopDongChoDuyetFull = useSelector(
    (state) => state.listHopDongChoDuyetFull
  );
  const dataSearch = useSelector((state) => state.dataSearchHopDongChoDuyet);

  const [isShowDuyet, setShowDuyet] = useState(true);
  const XacNhan = () => {
    setShowDuyet(false);
    setTimeout(function () {
      onSubmit();
    }, 1000);
  }

  useEffect(() => {
    checkNoXau();
  }, []);

  const [IsNoXau, setIsNoXau] = useState(false);
  const checkNoXau = () => {
    CheckNoXauApi.checkNoXau(props.item.Phone, props.item.CMT).then((response) => {
      if (response && response.data && response.data.NoXau != null) {
        setIsNoXau(response.data.NoXau);
      }
    });
  }


  const onSubmit = () => {
    DanhSachHopDongChoDuyetApi.xacNhanGiaoTienHopDongChoDuyet(
      props.chovayId
    ).then((response) => {
      if (response.data.Error === 1) {
        pushNotification(response.data.Message, "error", "TOP_CENTER", 1000);
      } else {
        dispatch(getListHopDongChoDuyet(dataSearch));
        props.onHide();
        pushNotification(
          "Xác nhận giao tiền thành công",
          "success",
          "TOP_CENTER",
          1000
        );
      }
    });
  };
  return (
    <Modal
      {...props}
      size="modal-dialog modal-dialog"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left"
    >
      <Modal.Header>
        <h4 className="modal-title" id="myModalLabel16">
          <span className="btn-icon-right">
            <i class="fas fa-hand-holding-usd"  style={{scale:"80%"}}></i>

          </span>
          Xác nhận giao tiền
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body className="">
        <form className="form tat-toan form-horizontal">
          <div className="form-body">
            <div className="form-body">
              {IsNoXau == true ? (
                <>
                  <div className="col-md-12">
                    <div className="form-group row">
                      <label className="col-md-12 label-control text-left" for="projectinput2">
                        <div style={{ borderWidth: "1px", borderStyle: "solid", borderColor: "orange", borderRadius: "0.25rem", backgroundColor: "#ffedcb", color: "#d50000", padding: "3px", textAlign: "center" }}>
                          <i className="mdi mdi-information-outline"></i><span style={{ paddingLeft: "5px" }}>Khách hàng {props.item.CustomerName} đang ở tình trạng nợ xấu</span>
                        </div>
                      </label>
                    </div>
                  </div>
                </>
              ) : (<> </>)}
              <div className="col-md-12">
                <div className="form-group row">
                  <label
                    className="col-md-12 label-control text-left"
                    for="projectinput2"
                  >
                    <span class="canh-bao">
                      Đã chuyển tiền cho khách hàng{" "}
                      <span class="blue">{props.item.CustomerName}</span> hợp đồng{" "}
                      <span class="blue">{props.item.Code}</span>
                    </span>
                  </label>
                </div>  </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        {isShowDuyet && (
          <button
            type="button"
            className="btn btn-new-main btn-checknew"
            onClick={XacNhan}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-check"></i>
            </span>
            Xác nhận
          </button>
        )}
        <button
          type="button"
          className="btn btn-new-main btn-closenew"
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>
          Đóng
        </button>
      </Modal.Footer>
    </Modal >
  );
};
